<template>
    <div>
        <div :id="btnId"
            class="w-100 border border-blue-300 bg-blue-300"
            :class="{'opacity-30': isBtnDisable}">
            <div class="py-1.5 text-white text-2xl text-center"
                v-html="btnMsg"
                @click="clickButton()"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PrimaryButton',
    props: {
        btnId: String,
        btnMsg: String,
        isBtnDisable: Boolean
    },
    methods: {
        clickButton: function () {
            if (this.isBtnDisable) return;

            this.$emit('onClick');
        }
    }
}
</script>